import React, { FC } from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';

import { SearchableSelectType } from '../../../components/inputs/searchableSelect';
// components
import AampeTooltip from '../../../components/shared/AampeTooltip/AampeTooltip';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// models
import {
    CompoundTriggerModel,
    TriggerDisplayNames,
} from '../../../models/compound-trigger.model';

interface TriggerOnHoverDataProps
    extends OptionProps<SearchableSelectType, boolean> {
    trigger?: CompoundTriggerModel;
}

const TriggerOnHoverData: FC<React.PropsWithChildren<TriggerOnHoverDataProps>> =
    ({ trigger, ...props }) => {
        return (
            <components.Option {...props}>
                <AampeTooltip
                    title={
                        props.isDisabled && trigger ? (
                            <Text>
                                This message groups is using CMS data. We
                                currently don't support the combination of{' '}
                                {TriggerDisplayNames[trigger?.trigger_type!]}{' '}
                                trigger with CMS data.
                            </Text>
                        ) : (
                            trigger &&
                            trigger.description && (
                                <Container>
                                    <TextLabel>Description</TextLabel>
                                    <TextBox>
                                        <Text>{trigger.description}</Text>
                                    </TextBox>
                                </Container>
                            )
                        )
                    }
                    customZIndex={4000}
                    placement={'right'}
                    arrow
                >
                    <Label isDisabled={props.isDisabled}>{props.label}</Label>
                </AampeTooltip>
            </components.Option>
        );
    };

const Container = styled.div(() => ({
    minWidth: 300,
    maxWidth: 500,
    display: 'flex',
    flexDirection: 'column',
    padding: aampeTheme.spacing4(4),
}));

const TextLabel = styled.span(() => ({
    color: aampeTheme.colors.white,
    fontWeight: 'bold',
}));

const TextBox = styled.div(() => ({
    overflow: 'auto',
}));

const Text = styled.span(() => ({
    color: aampeTheme.colors.white,
}));

const Label = styled.div<{ isDisabled: boolean }>(({ isDisabled }) => ({
    color: isDisabled
        ? aampeTheme.colors.textAccessibleWG01
        : aampeTheme.colors.neutral09,

    cursor: isDisabled ? 'not-allowed' : 'default',
}));

export default TriggerOnHoverData;
